/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrganizationPortalAdminAllOf,
    OrganizationPortalAdminAllOfFromJSON,
    OrganizationPortalAdminAllOfFromJSONTyped,
    OrganizationPortalAdminAllOfToJSON,
} from './OrganizationPortalAdminAllOf';
import {
    PortalAdmin,
    PortalAdminFromJSON,
    PortalAdminFromJSONTyped,
    PortalAdminToJSON,
} from './PortalAdmin';
import {
    PortalAdminRole,
    PortalAdminRoleFromJSON,
    PortalAdminRoleFromJSONTyped,
    PortalAdminRoleToJSON,
} from './PortalAdminRole';
import {
    PortalAdminStatus,
    PortalAdminStatusFromJSON,
    PortalAdminStatusFromJSONTyped,
    PortalAdminStatusToJSON,
} from './PortalAdminStatus';

/**
 * 
 * @export
 * @interface OrganizationPortalAdmin
 */
export interface OrganizationPortalAdmin {
    /**
     * A portal admin unique identifier.
     * @type {string}
     * @memberof OrganizationPortalAdmin
     */
    portalAdminId?: string;
    /**
     * The email address of the workspace admin.
     * @type {string}
     * @memberof OrganizationPortalAdmin
     */
    email: string;
    /**
     * The first name, displayed only within the portal workspace.
     * @type {string}
     * @memberof OrganizationPortalAdmin
     */
    firstName?: string;
    /**
     * The last name, displayed only within the portal workspace.
     * @type {string}
     * @memberof OrganizationPortalAdmin
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationPortalAdmin
     */
    timezone?: string;
    /**
     * The preferred locale used for communication, in BCP 47 format.
     * @type {string}
     * @memberof OrganizationPortalAdmin
     */
    locale?: string;
    /**
     * 
     * @type {PortalAdminRole}
     * @memberof OrganizationPortalAdmin
     */
    role: PortalAdminRole;
    /**
     * 
     * @type {PortalAdminStatus}
     * @memberof OrganizationPortalAdmin
     */
    status?: PortalAdminStatus;
    /**
     * The timestamp that the audit event record was created.
     * @type {Date}
     * @memberof OrganizationPortalAdmin
     */
    lastUpdatedInviteStatus?: Date;
    /**
     * The number of milliseconds that have elapsed since the Unix epoch. Last seen is an approximate of the user's last login / session.
     * @type {number}
     * @memberof OrganizationPortalAdmin
     */
    lastSeen?: number;
    /**
     * The organization's unique identifier.
     * @type {string}
     * @memberof OrganizationPortalAdmin
     */
    organizationId: string;
    /**
     * The organization's type
     * @type {string}
     * @memberof OrganizationPortalAdmin
     */
    organizationType?: string;
}

export function OrganizationPortalAdminFromJSON(json: any): OrganizationPortalAdmin {
    return OrganizationPortalAdminFromJSONTyped(json, false);
}

export function OrganizationPortalAdminFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationPortalAdmin {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'portalAdminId': !exists(json, 'portalAdminId') ? undefined : json['portalAdminId'],
        'email': json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'locale': !exists(json, 'locale') ? undefined : json['locale'],
        'role': PortalAdminRoleFromJSON(json['role']),
        'status': !exists(json, 'status') ? undefined : PortalAdminStatusFromJSON(json['status']),
        'lastUpdatedInviteStatus': !exists(json, 'lastUpdatedInviteStatus') ? undefined : (new Date(json['lastUpdatedInviteStatus'])),
        'lastSeen': !exists(json, 'lastSeen') ? undefined : json['lastSeen'],
        'organizationId': json['organizationId'],
        'organizationType': !exists(json, 'organizationType') ? undefined : json['organizationType'],
    };
}

export function OrganizationPortalAdminToJSON(value?: OrganizationPortalAdmin | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'portalAdminId': value.portalAdminId,
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'timezone': value.timezone,
        'locale': value.locale,
        'role': PortalAdminRoleToJSON(value.role),
        'status': PortalAdminStatusToJSON(value.status),
        'lastUpdatedInviteStatus': value.lastUpdatedInviteStatus === undefined ? undefined : (value.lastUpdatedInviteStatus.toISOString()),
        'lastSeen': value.lastSeen,
        'organizationId': value.organizationId,
        'organizationType': value.organizationType,
    };
}

